import React from 'react'
import { SUB_DIRECTORY } from '../../common/constant'

const OurApp = () => {

    return (
        <>
            <div className="mt-3">
                <span className="fw-bold">Download Our App</span>
                <div className="card mt-3 shadow">
                    <div className="card-body">
                        <div className="text-center">
                            <img
                                src={`${SUB_DIRECTORY}/assets/images/download_app_bg.jpg`}
                                className="img-fluid"
                                alt=""
                            />
                            <p className="fw-600">
                                Sign-Up new app, <br /> made just for you! Its Easy &amp;
                                Smart.
                            </p>
                        </div>
                        <div className="text-center d-flex px-0 px-lg-5">
                            <img
                                src={`${SUB_DIRECTORY}/assets/images/Android-Download.png`}
                                className="w-50 mt-2 me-1"
                                alt=""
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    window.open('https://play.google.com/store/apps/details?id=com.pinc.retail.pincinsurance', '_blank')

                                }}
                            />
                            <img
                                src={`${SUB_DIRECTORY}/assets/images/IOS-Download.png`}
                                className="w-50 mt-2 ms-1"
                                alt=""
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                    window.open('https://apps.apple.com/in/app/pinc-insurance/id1484612263', '_blank')

                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OurApp;